<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader"><i class="fa fa-spinner fa-spin gt-refresh"></i></div>
}
  @if (!showFormLoader) {
<div class="form-horizontal">
    <ul class="nav nav-pills" role="tablist">
      <li [class.active]="step === 1"><a class="btn-sm" (click)="step = 1" style="cursor: pointer;">Step 1</a></li>
      <li [class.active]="step === 2"><a class="btn-sm" (click)="step = 2" style="cursor: pointer;">Step 2</a></li>
      <li [class.active]="step === 3"><a class="btn-sm" (click)="step = 3" style="cursor: pointer;">Step 3</a></li>
    </ul>

    @if (step === 1) {
<div>
      <div class="row-space"><label>Rule Key</label><input class="form-control" [(ngModel)]="ruleModel.RULE_KEY" [disabled]="!isNewRule" /></div>
      <div class="row-space"><label>Rule Name</label><input class="form-control" [(ngModel)]="ruleModel.RULE_NAME" /></div>
      <div class="row-space"><label>Rule Description</label><textarea class="form-control" rows="3" [(ngModel)]="ruleModel.RULE_DESC"></textarea></div>
      <div class="row-space"><label>Rule Path</label><input class="form-control" [(ngModel)]="ruleModel.RULE_PATH" /></div>
      <div class="row-space">
        <label>Rule Active</label>
        <select class="form-control" [(ngModel)]="ruleModel.RULE_ACTIVE_FLAG"><option value="1">Yes</option><option value="0">No</option></select>
      </div>
    </div>
}

    @if (step === 2) {
<div>
      <div class="row-space">
        <label>New Action Key</label>
        <div class="inline-actions">
          <input class="form-control" [(ngModel)]="newActionKey" />
          <button class="reset-button" type="button" (click)="addAction()">Add</button>
        </div>
      </div>
      @if (allLinkedActions.length > 0) {
<table class="table table-bordered custom-table">
        <thead><tr><th>Action Key</th><th>Action Name</th><th>Action</th></tr></thead>
        <tbody>
          @for (action of allLinkedActions; track $index) {
<tr>
            <td>{{ action.action_key || action.ACTION_KEY }}</td>
            <td>{{ action.action_name || action.ACTION_NAME }}</td>
            <td><button class="cancel-button" type="button" (click)="delinkAction(action)">Delink</button></td>
          </tr>
}
        </tbody>
      </table>
}
    </div>
}

    @if (step === 3) {
<div>
      <div class="row-space">
        <label>New Cache Object Key</label>
        <div class="inline-actions">
          <input class="form-control" [(ngModel)]="newCacheObjectKey" />
          <button class="reset-button" type="button" (click)="addCacheObject()">Add</button>
        </div>
      </div>
      @if (allLinkedCacheObjects.length > 0) {
<table class="table table-bordered custom-table">
        <thead><tr><th>Cache Key</th><th>Cache Name</th><th>Action</th></tr></thead>
        <tbody>
          @for (cache of allLinkedCacheObjects; track $index) {
<tr>
            <td>{{ cache.drools_cache_key || cache.CACHE_KEY }}</td>
            <td>{{ cache.cache_name || cache.CACHE_NAME }}</td>
            <td><button class="cancel-button" type="button" (click)="delinkCacheObject(cache)">Delink</button></td>
          </tr>
}
        </tbody>
      </table>
}
    </div>
}

    <div class="step-actions">
      <button class="reset-button" type="button" (click)="prevStep()" [disabled]="step === 1">Previous</button>
      <button class="reset-button" type="button" (click)="nextStep()" [disabled]="step === 3">Next</button>
    </div>
  </div>
}
</div>
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isLoading || isSaveClicked" (click)="save()">
    @if (isLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
